import Hero from '../components/Hero'
import Marquee from '../components/Marquee'
import Services from '../components/Services'
import WebPortfolio from '../components/WebPortfolio'
import Stats from '../components/Stats'
import Contact from '../components/Contact'
import Footer from '../components/Footer'
import { usePageMeta } from '../hooks/usePageMeta'

export default function Home() {
  usePageMeta()
  return (
    <div>
      <Hero />
      <Marquee />
      <Services />
      <WebPortfolio />
      <Stats />
      <Contact />
      <Footer />
    </div>
  )
}
